/* eslint-disable no-lone-blocks */
import React from "react";
import TertiaryButton from "../../Buttons/TertiaryButton";
import useEditAttributePopup from "./useEditAttributePopup";
import PopupHeader from "../PopupHeader";
import Input from "../../Input/Input";
import Dropdown from "../../Dropdown/Dropdown";
import formatAttributeInputType from "../../../../helpers/Attributes/formatAttributeInputType";
import { ATTRIBUTE_TYPES } from "../../../../constants";

const EditAttributePopup = ({ popupData, closePopup }) => {
  const {
    editedAttribute,
    handleChangeDetail,
    handleChangeOptions,
    handleChangeUnitOptions,
    handleChangeFieldType,
    handleFinish,
    isDDL,
    isUnit,
    formatForDDL,
  } = useEditAttributePopup({
    popupData,
    closePopup,
  });

  return (
    <>
      <PopupHeader headerTitle="Edit Attribute" closePopup={closePopup} />

      <div
        style={{ minHeight: "400px", minWidth: "360px" }}
        className="flex flex-col gap-6 justify-start p-6 border-es-light-grey rounded-xl"
      >
        <div className="flex flex-col gap-6 h-full">
          <Input
            onChange={(value) => handleChangeDetail(value)}
            value={editedAttribute?.detail}
            label="Name"
          />
          <Dropdown
            options={ATTRIBUTE_TYPES}
            value={{
              label: formatAttributeInputType(editedAttribute?.fieldType),
              value: editedAttribute?.fieldType,
            }}
            onChange={(val) => handleChangeFieldType({ val })}
            disableClear
          />
          {isDDL && (
            <Dropdown
              label="Options"
              isMulti
              isCreatable
              disableClear
              hideIndicator
              noOptionsMessage
              hideDropdownIndicator
              value={formatForDDL?.options}
              customStyle={{ menu: { display: "none" } }}
              onChange={(val) => handleChangeOptions({ val })}
            />
          )}
          {isUnit && (
            <Dropdown
              label="Units"
              isMulti
              isCreatable
              disableClear
              hideIndicator
              noOptionsMessage
              placeholder=""
              hideDropdownIndicator
              value={formatForDDL?.units}
              customStyle={{ menu: { display: "none" } }}
              onChange={(val) => handleChangeUnitOptions({ val })}
            />
          )}
        </div>
      </div>
      <div className="flex flex-row items-center justify-between h-fit w-full gap-4 p-4">
        <TertiaryButton
          onClick={() => handleFinish()}
          title="Submit"
          className="border border-es-green p-2 text-es-green hover:text-es-white"
        />
        <TertiaryButton
          onClick={() => closePopup()}
          title="Close"
          className="border border-es-green p-2 text-es-green hover:text-es-white"
        />
      </div>
    </>
  );
};

export default EditAttributePopup;
